"use client"

import { useState } from "react"

export default function UsuarioForm({ onSubmit, onCancel, instituicoes = [], isAdmin = false }) {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    senha: "",
    papel: "secretaria",
    instituicao_id: "",
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Nome *"
        value={formData.nome}
        onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
        required
      />
      <input
        type="email"
        placeholder="Email *"
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        required
      />
      <input
        type="password"
        placeholder="Senha *"
        value={formData.senha}
        onChange={(e) => setFormData({ ...formData, senha: e.target.value })}
        required
        minLength={6}
      />

      <select value={formData.papel} onChange={(e) => setFormData({ ...formData, papel: e.target.value })} required>
        {isAdmin && <option value="admin">Administrador</option>}
        <option value="diretor">Diretor</option>
        <option value="diretor_pedagogico">Diretor Pedagógico</option>
        <option value="diretor_admin">Diretor Administrativo</option>
        <option value="secretaria">Secretaria</option>
      </select>

      {isAdmin && (
        <select
          value={formData.instituicao_id}
          onChange={(e) => setFormData({ ...formData, instituicao_id: e.target.value })}
          required
        >
          <option value="">Selecione a Instituição</option>
          {instituicoes.map((inst) => (
            <option key={inst.id} value={inst.id}>
              {inst.nome}
            </option>
          ))}
        </select>
      )}

      <div className="modal-actions">
        <button type="submit" className="btn-primary">
          Cadastrar
        </button>
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </form>
  )
}
